import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import HomePage from 'components/pages/home/HomePage';

import { getPageValues } from 'support/analytics/analyticsHelper';

import useTracking from 'hooks/analytics';
import { TrackingData } from 'store-types';

interface HomeProps {
  onError?: (error: unknown) => void;
}

const trackHome = (tracker: (data?: TrackingData) => unknown) => {
  const pageData = {
    pageType: 'main',
    ...getPageValues('main'),
  };

  tracker(pageData);
};

const Home = ({ onError = () => {} }: HomeProps) => {
  const { trackPage: tracker } = useTracking();
  useEffect(() => {
    trackHome(tracker);
  }, [tracker]);

  return (
    <Switch>
      <Route path="/">
        <HomePage onError={onError} />
      </Route>
    </Switch>
  );
};

export default Home;
